import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
// Anonymous tracking removed; consult local consent only

export const usePageTracking = () => {
  const location = useLocation();
  const trackPageView = (page: string, referrer?: string) => {
    // no-op tracking; may integrate with real analytics provider later
    console.log('track page view (disabled)', page, referrer);
  };
  const hasAnalyticsConsent = () => {
    try {
      const raw = localStorage.getItem('user_consent');
      if (!raw) return false;
      const parsed = JSON.parse(raw);
      return !!parsed.analytics;
    } catch { return false; }
  };

  useEffect(() => {
    // Only track if user has given consent
    if (hasAnalyticsConsent()) {
      const page = location.pathname + location.search;
      const referrer = document.referrer || undefined;
      
      // Track the page view
      trackPageView(page, referrer);
      
      // Update page title for better tracking
      const pageTitle = document.title || page;
      console.log(`Page tracked: ${pageTitle} (${page})`);
    }
  }, [location, trackPageView, hasAnalyticsConsent]);
};

export default usePageTracking; 